import React,{useState} from "react";
import { Formik, Form } from "formik";
import { Box, TextField, Button, Typography } from "@mui/material";
import * as Yup from "yup";
import { useNavigate } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import {API_BASE}from '../../utils/api';
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';


const validationSchema = Yup.object({
  name: Yup.string().required("Category name is required"),
  slug: Yup.string().required("Slug is required"),
  description: Yup.string().required("Description is required"),
  image: Yup.mixed()
  .required("Image is required")
  .test("fileSize", "File size must be 5MB or less", (value) => !value || value.size <= 5 * 1024 * 1024)
  .test("fileType", "Only PNG and JPEG images are allowed", (value) =>
    !value || ["image/png", "image/jpeg"].includes(value.type)
  ),
});

const CategoryAdd = () => {
  const navigate = useNavigate();
  const [imagePreview, setImagePreview] = useState(null);
  const excludedWords = ["is", "of", "the", "and", "or", "in", "to", "with"];
  const [fileInputKey, setFileInputKey] = useState(Date.now());
   
const capitalizeWords = (str) => {
  return str
    .split(" ")
    .map((word) =>
      excludedWords.includes(word.toLowerCase())
        ? word.toLowerCase()
        : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    )
    .join(" ");
};

  const generateSlug = (name) => {
    return name.toLowerCase().replace(/[^a-z0-9]+/g, '-');
  };

  const handleImageChange = (e, setFieldValue) => {
    const file = e.target.files[0];
    if (file) {
      setFieldValue("image", file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleNameChange = (e, setFieldValue) => {
    const name = e.target.value;
    const formattedName = capitalizeWords(name);
    setFieldValue("name", formattedName);


    setFieldValue("slug", generateSlug(name));
  };

  const handleSubmit = async (values, { setSubmitting,resetForm,setFieldValue  }) => {
    setSubmitting(true);

    try {
        
        const checkResponse = await fetch(`${API_BASE}/api/categories/check?name=${values.name.trim()}`);
        const checkData = await checkResponse.json();

        if (checkData.exists) {
          toast.warning("Category already exists!");
            setSubmitting(false);
            return;
        }

        const formData = new FormData();
        formData.append("name", values.name);
        formData.append("slug", values.slug);
        formData.append("description", values.description);
        if (values.image) {
            formData.append("image", values.image);
        }

        const response = await fetch(`${API_BASE}/api/categories`, {
            method: "POST",
            body: formData,
        });

        const data = await response.json();
        if (response.ok) {
          toast.success("Category added!Make sure to enable to show in customer UI");
            resetForm(); 
        setImagePreview(null); 
        //setFileInputKey(Date.now());
        setFileInputKey(Date.now());

            setFieldValue("image", null);
        } else {
          toast.error("Error adding category: " + data.message);
        }
    } catch (error) {
        console.error("Error submitting category:", error);
        toast.error("Failed to add category");
    } finally {
        setSubmitting(false);
    }
};


  return (
<>
    <Formik

      initialValues={{ name: "", slug: "", image: null, description: "" }}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ setFieldValue, handleBlur, values, touched, errors, isSubmitting }) => (
        <Form className="container">
          <Box
            display="grid"
            gap="30px"
            gridTemplateColumns="repeat(4, minmax(0, 1fr))"
            sx={{
              "& > div": { gridColumn: "span 4" },
            }}
          >
           <Box style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
  <IconButton
    onClick={() => navigate('/categories')}
    className="back-button"
    style={{
      backgroundColor: '#e0e0e0',
      border: '1px solid #ccc',
      borderRadius: '50%',
      padding: '5px',
      color: '#333',
    }}
  >
    <KeyboardBackspaceIcon fontSize="medium" />
  </IconButton>
  <h5 className="heading">Add Category</h5>
</Box>

            <TextField 
              style={{ width: "100%" }}
              variant="filled"
              label="Category Name"
              onBlur={handleBlur}
              onChange={(e) => handleNameChange(e, setFieldValue)}
              value={values.name}
              name="name"
              error={touched.name && Boolean(errors.name)}
              helperText={touched.name && errors.name}

              disabled={isSubmitting}
            />

            <TextField
              style={{ width: "100%" }}
              variant="filled"
              label="Description"
              onBlur={handleBlur}
              onChange={(e) => setFieldValue("description", e.target.value)}
              value={values.description}
              name="description"
              error={touched.description && Boolean(errors.description)}
              helperText={touched.description && errors.description}

              disabled={isSubmitting}
            />
<Box sx={{ gridColumn: "span 4" }}>
<input
  key={fileInputKey} 
  type="file"
  onChange={(e) => handleImageChange(e, setFieldValue)}
  accept="image/png, image/jpeg"
/>

              {touched.image && errors.image && (
                <Typography color="error">{errors.image}</Typography>
              )}

             
              {imagePreview && (
                <Box mt={2}>
                  
                  <img
                    src={imagePreview}
                    alt="Preview"
                    style={{ width: "150px", height: "auto", borderRadius: "5px" }}
                  />
                </Box>
              )}
              
            </Box>
            <Box className="button">
              <Button
                type="submit"
                variant="contained"
                color="primary"
                
                disabled={isSubmitting}
              >
                Save
              </Button>
            </Box>
          </Box>
        </Form>
      )}
      
    </Formik>
    <ToastContainer position="top-center" autoClose={3000} />
    </>
  );
};
export default CategoryAdd
           